import { DatePipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { PaymentInfo } from 'src/shared/models/payment.model';

@Component({
	selector: 'vl-booking-payment-information',
	templateUrl: './booking-payment-information.component.html',
	styleUrls: ['./booking-payment-information.component.scss'],
	imports: [TranslatePipe, NgIf, NgTemplateOutlet, DatePipe],
})
export class BookingPaymentInformation implements OnInit {
	@Input() paymentInfo: PaymentInfo;
	@Input() showHeader = true;

	constructor() {
	}

	ngOnInit() {
		this.paymentInfo.amountToPay = this.paymentInfo.amountToPay ? (+this.paymentInfo.amountToPay).toFixed(2) : '';
	}
}
